import { sendMemberInvitation } from 'email'
import { isEmpty } from 'lodash'
import { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useClipboard } from 'ui-components'
import { getInviteLink } from 'utils'

import {
  closeInviteMemberDialog,
  useInviteMemberDialog
} from '~workspace/states/ui'
import { useWorkspace } from '~workspace/states/workspace'
import View from './view'

const InviteMemberDialog = () => {
  const dispatch = useDispatch()
  const { open } = useInviteMemberDialog()
  const workspace = useWorkspace()

  const inviteLink = useMemo(() => {
    const { id: workspaceId, name: workspaceName, inviteId } = workspace
    return getInviteLink({
      workspaceId,
      workspaceName,
      inviteId
    })
  }, [workspace])

  const [, copyToClipboard] = useClipboard()

  const isAlreadyMember = (email) => {
    const isMember = workspace.memberCollection.items.find(
      (member) => member.user.email === email
    )
    return isMember
  }

  const handleEmailValidate = (email) => {
    return isAlreadyMember(email)
  }

  const handleCopiedLinkClick = () => {
    copyToClipboard(inviteLink)
  }

  const handleSendInvitesClick = async (event, emails) => {
    await sendMemberInvitation({
      toAddresses: emails,
      workspace
    })
  }

  const handleClose = () => {
    dispatch(closeInviteMemberDialog())
  }

  return (
    <View
      open={open}
      workspace={workspace}
      diabledCopiedLinkButton={isEmpty(inviteLink)}
      onEmailValidate={handleEmailValidate}
      onCopiedLinkClick={handleCopiedLinkClick}
      onSendInvitesClick={handleSendInvitesClick}
      onClose={handleClose}
    />
  )
}

export { InviteMemberDialog }
export default InviteMemberDialog
